import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ComponentsModule, FormModule } from "@stdoutsrl/design-kit";
import { PagesComponent } from "./pages/pages.component";
import { LoginComponent } from "./login/login.component";
import { UserComponent } from "./pages/user/user.component";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { TranslocoRootModule } from "./transloco-root.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RegistrationComponent } from "./registration/registration.component";
import { ExampleMonouseComponent } from "./tables-custom-actions/example-table-component.component";
import { RecoveryPasswordComponent } from "./recovery-password/recovery-password.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { RouteReuseStrategy } from "@angular/router";
import { CustomReuseStrategy } from "./reuse";
import { MenuComponent } from "./components/menu/menu.component";
import { ContainerComponent } from "./pages/container.component";
import { WhoComponent } from "./pages/who/who.component";
import { ShipsComponent } from "./pages/ships/ships.component";
import { BookingComponent } from "./pages/booking/booking.component";
import { ContactsComponent } from "./pages/contacts/contacts.component";
import { ProfileComponent } from "./pages/profile/profile.component";
import { AvailabilityComponent } from "./pages/availability/availability.component";
import { FooterComponent } from "./components/footer/footer.component";
import { PrivacyComponent } from "./pages/privacy/privacy.component";
@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    LoginComponent,
    UserComponent,
    RegistrationComponent,
    ExampleMonouseComponent,
    RecoveryPasswordComponent,
    ChangePasswordComponent,
    MenuComponent,
    ContainerComponent,
    WhoComponent,
    ShipsComponent,
    BookingComponent,
    ContactsComponent,
    ProfileComponent,
    AvailabilityComponent,
    FooterComponent,
    PrivacyComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslocoRootModule,
    ComponentsModule,
    FormModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi()),{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy }],
})
export class AppModule {}
